import styled from 'styled-components';
import { LongBody } from 'components/Typography';

export const StyledCaptions = styled(LongBody)`
  && {
    margin-bottom: 20px;
    line-height: 18px;
  }
`;

export const StyledCaptionsTitle = styled(LongBody)`
  && {
    font-size: 18px;
    margin-bottom: 20px;
    line-height: 24px;
  }
`;
